
<div id="page" class="col-lg-12">
    <div style="text-align:center; margin-top: 60px;">
      <h3><u><b><i>GENERAR REPORTE DE CUENTAS CONTABLES</i></b></u></h3>
    </div>
    <div id="fechadesdehasta" style="text-align:center;" class="titulos1">
        <mat-form-field>
          <input matInput [matDatepicker]="picker" placeholder="Fecha desde" [value]="dateValue" (dateInput)="addEvent('input', $event)">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
      &nbsp;
      <mat-form-field>
          <input matInput [matDatepicker]="picker2" placeholder="Fecha hasta" [value]="dateValue2" (dateInput)="addEvent2('input', $event)">
          <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
      </mat-form-field>
    </div>
    <hr>
    <div style="text-align:center;">
      <button [disabled]="control==false" (click)="getRepo()" type="button" class="btn btn-success" data-toggle="modal" data-target="#MODALREPO">
          GENERAR REPORTE
      </button>
    </div>
    

    <hr>

</div>


<!-- Modal REPORTE -->
<div style="margin-top: 100px" class="modal fade" id="MODALREPO" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div id="modito" class="modal-content">
            <div class="modal-header">
                <p style="font-weight: bold" class="modal-title" id="exampleModalLabel">Generando..</p>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
            </div>
            <div class="modal-body" #REPORTE>
                <app-loading class="m-5" *ngIf="loading"></app-loading> 
            </div>
            <button id="salemodal" hidden type="button" class="btn btn-secondary" data-dismiss="modal">Volver</button>
        </div>
    </div>
</div>
